(function (Product, $, undefined) {
  var $window = $(window),
      $document = $(document),
      $tabItems = $('.cd-tabs-navigation a, .js-review-trigger'),
      $tabContentWrapper = $('.cd-tabs-content', '#product-description'),
      $tabNav = $('nav','#product-description');

  var checkScrolling = function(tabs) {
      var totalTabWidth = parseInt(tabs.children('.cd-tabs-navigation').width()),
          tabsViewport = parseInt(tabs.width());
      if (tabs.scrollLeft() >= totalTabWidth - tabsViewport) {
          tabs.parent('.cd-tabs').addClass('is-ended');
      } else {
          tabs.parent('.cd-tabs').removeClass('is-ended');
      }
  };

  var changeProductImage = function(targetIndex) {
      // adjust HTML/classes of displayed image
      var $scope = $('#product-template-form');
      $('.product-photo-container > div.magnify',$scope).removeClass('magnify').css('display', 'none');
      $('.product-photo-container > div:nth-child(' + (targetIndex + 1) + ')',$scope).addClass('magnify').attr('style', '');

      // adjust active class of thumbnail
      $('ul.product-photo-thumbs li.active',$scope).removeClass('active');
      $('ul.product-photo-thumbs li:nth-child(' + (targetIndex + 1) + ')',$scope).addClass('active');
  };

  var bindUIActions = function () {
    $('.venobox').venobox();
    $('.perfect-accessories').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      autoplay: true
    });
    $document.on('click', 'ul.product-photo-thumbs li', function (event) {
        event.preventDefault();
        var i = $(this).data('index');
        if ($(this).hasClass('active')) {
            return;
        }
        changeProductImage(i);
    });
    $('.product-photo-container > div','#product-template-form').on('match-image-to-selected-variant', function (event) {
        changeProductImage($(this).index());
    });

    $('.product-photo-thumbs', '#product-template-form').slick({
      arrows: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      centerMode: false
    });

    $('.write-review-link', '#product-template-form').on('click', function () {
        $('.cd-tabs-navigation li a, .cd-tabs-content li', '#product-description').removeClass('selected');
        $('[data-content="reviews"]', '#product-description').addClass('selected');
        $('.js-all-reviews').slick('setPosition');
        if(IsMobile.check()) {
          $('.js-slick').slick('setPosition');
        }
        return true;
    });

    $tabItems.on('click', function (event) {
        var $selectedItem = $(this),
            tab = $selectedItem.data('content');
        if($selectedItem.hasClass('js-review-trigger')) {
          $selectedItem = $tabNav.find('a[data-content="' + $selectedItem.data('content') + '"]');
        } else {
          event.preventDefault();
        }
        if (!$selectedItem.hasClass('selected')) {
            var selectedTab = $selectedItem.data('content'),
                selectedContent = $tabContentWrapper.find('li[data-content="' + selectedTab + '"]');

            $tabItems.removeClass('selected');
            $selectedItem.addClass('selected');
            selectedContent.addClass('selected').siblings('li').removeClass('selected');
        }
        var $el = '';
        if(tab == 'reviews') {
          $el = $('.js-all-reviews');
          if(IsMobile.check()) {
            $el = $('.js-all-reviews,.js-slick');
          }
        } /*else if (tab == 'qna') {
          $el = $('.js-all-answers');
        }*/
        $el.slick('setPosition');
    });
    $window.on('resize', function () {
        checkScrolling($tabNav);
        $tabContentWrapper.css('height', 'auto');
    });
    $tabNav.on('scroll', function () {
        checkScrolling($(this));
    });

  };

  Product.init = function () {
    bindUIActions();
    checkScrolling($tabNav);
    $('.js-alternatives').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        responsive: [{
            breakpoint: 640,
            settings: {
                slidesToShow: 2
            }
        }]
    });
  };

}(window.Product = window.Product || {}, jQuery));
